import React from 'react'
import Header from '../Components/Header/page'
import Footer from '../Components/Footer/Footer'
import './style.css'

const Thanks = () => {
    return (
        <>
            <Header />
            <section className='thankyou'>
                <div className='container'>
                    <div className='heading'>
                        <h1>Thank You !</h1>

                        <h6>Your Appointment Book Successfully</h6>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default Thanks